<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Blog Details Right  Sidebar" />
            <BlogDetailsRightSidebar />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import BlogDetailsRightSidebar from '../BlogDetailsRightSidebar/BlogDetailsRightSidebar'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'BlogDetailsRightSidebarPage',
    components: {
        NavBar,
        PageTitle,
        BlogDetailsRightSidebar,
        FooterComp,
    }
}
</script>